import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import Hls from 'hls.js';
// import { signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { WsService } from 'src/app/services/ws.service';


@Component({
  selector: 'app-asset-live-monitoring',
  templateUrl: './asset-live-monitoring.component.html',
  styleUrls: ['./asset-live-monitoring.component.css']
})
export class AssetLiveMonitoringComponent implements OnInit {

  isLoading: any = false
  objectInfoList: any = []
  searchFilter: any = ""

  faceSub?: Subscription;
  recognizedFaces: any = [];
  recognizing = false;

  constructor(
    private api: ApiService,
    private ws: WsService,
    private generic_service: GenericService
  ) { }

  getAllByAssetMonitoringAndCid(assetMonitoring: any) {
    this.generic_service.getAllByAssetMonitoringAndCid(assetMonitoring).subscribe(
      (response: any) => {
        console.log(response.response)
        let objectInfo: any = []
        for (let list of response.response) {
          if (list.assetMonitoring) {
            objectInfo.push(list)
          }

        }
        this.objectInfoList = objectInfo || []

      },
      (error: any) => {
        console.log(error)
      }
    )
  }



  async startRecognition() {
    if (!this.cameraId) {
      this.showToast('Error', 'Start stream first');
      return;
    }

    try {
      const channel = this.cameraId.split('_').pop();

      const encodedUser = encodeURIComponent(this.username);
      const encodedPass = encodeURIComponent(this.password);

      const rtspUrl =
        `rtsp://${encodedUser}:${encodedPass}@${this.ip}/Streaming/Channels/${channel}01`;

      await this.api.startRecognition({
        camera_id: this.cameraId,
        rtsp_url: rtspUrl
      }).toPromise();

      this.faceSub = this.ws
        .connectFaces(this.cameraId)
        .subscribe(data => {
          console.log('Faces WS:', data);

          this.recognizedFaces = data?.faces || [];
          this.drawDetections();
        });

      this.recognizing = true;
      this.showToast('Recognition', 'Started');
    } catch (e) {
      console.error(e);
      this.showToast('Recognition', 'Failed to start');
    }
  }

  async stopRecognition() {
    try {
      await this.api.stopRecognition({
        camera_id: this.cameraId
      }).toPromise();

      this.faceSub?.unsubscribe();
      this.recognizedFaces = [];
      this.recognizing = false;

      this.showToast('Recognition', 'Stopped');
    } catch (e) {
      console.error(e);
    }
  }


  getObjectInfoByWildSearch() {
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }
    this.generic_service.getObjectInfoByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  refresh() {
    this.searchFilter = ""
    this.getAllByAssetMonitoringAndCid(true)

  }


  @ViewChild('video', { static: true }) videoEl!: ElementRef<HTMLVideoElement>;
  @ViewChild('overlay', { static: true }) overlayEl!: ElementRef<HTMLCanvasElement>;
  @ViewChild('videoWrapper', { static: true }) videoWrapperEl!: ElementRef<HTMLDivElement>;

  selectedFiles: File[] = [];
  objectId = '';
  objectLabel = '';

  cameraId!: string;
  hls?: Hls;
  wsSub: any;

  alerts: any = [];
  showModal: any = [];

  // detections & thumbnails (all detections kept as before)
  latestDetections: any = [];
  detPollSub?: Subscription;

  // tracked (manually selected) ids - draw only these on video overlay
  trackedIds: any = [];

  // Drawing state (overlay)
  private drawing = false;
  private startX = 0;
  private startY = 0;
  private curX = 0;
  private curY = 0;
  private drawConfirmed = false;


  ip = '';
  username = '';
  password = '';
  channelId = '';

  streaming = false;
  selectedCamera: any = null;
  private boundFullscreenChange: any;

  ngOnInit() {
    // this.getAllObjectInfo()
    this.getAllByAssetMonitoringAndCid(true)
    // this.cameraId = this.route.snapshot.params['id'];
    // this.startStream();
    // this.openTrackPrompt();
    this.setupWebsocket();
    // setTimeout(() => this.startDetectionsPolling(), 500);

    // // attach pointer events for drawing on overlay
    // setTimeout(() => this.initOverlayEvents(), 200);

    this.boundFullscreenChange = this.onFullscreenChange.bind(this);
    document.addEventListener('fullscreenchange', this.boundFullscreenChange);
  }

  onFullscreenChange() {
    this.applyVideoAspectRatio();
    setTimeout(() => {
      this.resizeOverlay();
    }, 100);
  }

  streamCamera(list: any) {

    console.log(list);
    this.selectedCamera = list;
    if (this.streaming) {
      this.stop()
    }

    if (list.type == "CCTV") {
      this.ip = "";
      this.username = "";
      this.password = "";
      this.channelId = "";

      if (!list?.nameValue?.length) return;

      for (const val of list.nameValue) {
        switch (val.key) {
          case "IP Address":
            this.ip = val.value;
            break;
          case "User Name":
            this.username = val.value;
            break;
          case "Password":
            this.password = val.value;
            break;
          case "Camera Id":
            this.channelId = val.value;
            break;
        }
      }
      this.startStream()
    }


  }



  async startStream() {
    try {
      this.cameraId = `${this.ip}_${this.channelId}`;

      const res: any = await this.api.startStream({
        ip: this.ip,
        username: this.username,
        password: this.password,
        channel_id: this.channelId
      }).toPromise();
      this.setupWebsocket();
      setTimeout(() => this.startDetectionsPolling(), 500);

      // attach pointer events for drawing on overlay
      setTimeout(() => this.initOverlayEvents(), 200);
      const m3u8Path = res?.m3u8;
      if (!m3u8Path) throw new Error("Backend did not return m3u8");
      let backendOrigin = (this.api as any).base;
      if (backendOrigin.endsWith('/api')) backendOrigin = backendOrigin.slice(0, -4);
      if (backendOrigin.endsWith('/api/')) backendOrigin = backendOrigin.slice(0, -5);
      const playlist = `${backendOrigin}${m3u8Path}`;
      console.log(backendOrigin)
      console.log(m3u8Path)
      console.log(playlist)
      const video = this.videoEl.nativeElement;
      if (Hls.isSupported()) {
        this.hls = new Hls({ enableWorker: true, lowLatencyMode: true });
        this.hls.attachMedia(video);
        this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          this.hls!.loadSource(playlist);
          // this.hls!.on(Hls.Events.MANIFEST_PARSED, () => video.play());
          this.hls!.on(Hls.Events.MANIFEST_PARSED, () => {
            video.muted = true;

            const tryPlay = () => {
              if (video.clientWidth > 0 && video.clientHeight > 0) {
                video.play().catch(() => { });
              } else {
                requestAnimationFrame(tryPlay);
              }
            };

            tryPlay();
          });

        });
      } else if (video.canPlayType && video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = playlist;
        video.onloadedmetadata = () => video.play();
      } else {
        // if environment doesn't have alert (SSR) skip
        try { alert("HLS not supported"); } catch { }
      }
      video.addEventListener('loadedmetadata', () => {
        this.applyVideoAspectRatio();
        this.resizeOverlay();
      });
      video.addEventListener('loadeddata', () => {
        video.play().catch(() => { });
      });

      window.addEventListener('resize', () => {
        this.applyVideoAspectRatio();
        this.resizeOverlay();
      });
      this.streaming = true;
    } catch (err) {
      console.error(err);
      try { alert("Could not start stream"); } catch { }
    }
  }

  // overlay drawing init
  initOverlayEvents() {
    const canvas = this.overlayEl?.nativeElement;
    if (!canvas) return;
    // enable pointer events to draw
    canvas.style.pointerEvents = 'auto';

    canvas.addEventListener('pointerdown', (ev: PointerEvent) => this.onPointerDown(ev));
    canvas.addEventListener('pointermove', (ev: PointerEvent) => this.onPointerMove(ev));
    canvas.addEventListener('pointerup', (ev: PointerEvent) => this.onPointerUp(ev));
    canvas.addEventListener('pointerleave', (ev: PointerEvent) => this.onPointerUp(ev));
  }

  onPointerDown(ev: PointerEvent) {
    // start drawing only with left button (or you can check modifiers)
    if (ev.button !== 0) return;
    const canvas = this.overlayEl.nativeElement;
    const rect = canvas.getBoundingClientRect();
    this.drawing = true;
    this.drawConfirmed = false;
    this.startX = ev.clientX - rect.left;
    this.startY = ev.clientY - rect.top;
    this.curX = this.startX;
    this.curY = this.startY;
  }

  onPointerMove(ev: PointerEvent) {
    if (!this.drawing) return;
    const canvas = this.overlayEl.nativeElement;
    const rect = canvas.getBoundingClientRect();
    this.curX = Math.max(0, Math.min(ev.clientX - rect.left, canvas.width));
    this.curY = Math.max(0, Math.min(ev.clientY - rect.top, canvas.height));
    this.renderOverlay(); // draw temporary rect
  }

  async onPointerUp(ev: PointerEvent) {
    if (!this.drawing) return;
    this.drawing = false;
    this.drawConfirmed = true;
    this.renderOverlay(); // final rect
    // automatically try to select: convert to frame coords and call backend
    await this.confirmSelection();
  }

  // convert displayed canvas coords to FRAME coords and call backend
  async confirmSelection() {
    const video = this.videoEl.nativeElement;
    const canvas = this.overlayEl.nativeElement;
    if (!video || !canvas) return;

    // compute rect in canvas/display pixels
    const x1 = Math.round(Math.min(this.startX, this.curX));
    const y1 = Math.round(Math.min(this.startY, this.curY));
    const x2 = Math.round(Math.max(this.startX, this.curX));
    const y2 = Math.round(Math.max(this.startY, this.curY));
    if (x2 - x1 < 8 || y2 - y1 < 8) {
      // too small
      this.drawConfirmed = false;
      this.renderOverlay();
      return;
    }

    // video.videoWidth/video.videoHeight are the frame dimensions
    const frameW = video.videoWidth || 1280;
    const frameH = video.videoHeight || 720;

    // canvas width/height correspond to client display size; mapping:
    const scaleX = frameW / canvas.clientWidth;
    const scaleY = frameH / canvas.clientHeight;

    const frameBox: [number, number, number, number] = [
      Math.round(x1 * scaleX),
      Math.round(y1 * scaleY),
      Math.round(x2 * scaleX),
      Math.round(y2 * scaleY),
    ];

    try {
      const res: any = await this.api.selectBoxForMonitor(this.cameraId, frameBox).toPromise();
      if (res?.status === 'ok') {
        const id = res.selected_id;
        // add locally too
        const arr = [...this.trackedIds];
        if (!arr.includes(id)) arr.push(id);
        this.trackedIds = arr;
        this.showToast('Tracking set', `Selected id=${id}`);
        setTimeout(() => this.startDetectionsPolling(), 500);

        // attach pointer events for drawing on overlay
        setTimeout(() => this.initOverlayEvents(), 200);
      } else {
        this.showToast('Selection', 'Select request failed or no worker');
      }
    } catch (e) {
      console.error('selectBox error', e);
      this.showToast('Selection', 'Select request failed');
    } finally {
      // clear the drawn rect display after selection attempt (or you may keep it)
      this.drawConfirmed = false;
      this.renderOverlay();
    }
  }

  private detSub?: Subscription;

  startDetectionsPolling() {
    if (this.detSub) return;

    this.detSub = this.ws.connectDetections(this.ip + '_' + this.channelId).subscribe(payload => {
      console.log('WS DET:', payload);
      this.latestDetections = payload?.results || [];
      this.drawDetections();
    });
  }

  stopDetectionsPolling() {
    this.detSub?.unsubscribe();
    this.detSub = undefined;
  }

  // draw overlay boxes (only for trackedIds)
  drawDetections() {
    const canvas = this.overlayEl?.nativeElement;
    const video = this.videoEl?.nativeElement;
    if (!canvas || !video) return;
    const ctx = canvas.getContext('2d')!;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const vW = video.videoWidth || 1280;
    const vH = video.videoHeight || 720;
    const cW = canvas.width, cH = canvas.height;
    const scaleX = cW / vW;
    const scaleY = cH / vH;

    ctx.lineWidth = 2;
    ctx.font = '14px Arial';

    const tracked = new Set(this.trackedIds);

    for (const d of this.latestDetections) {
      if (!d.bbox) continue;
      if (!d.id || !tracked.has(d.id)) continue; // only draw selected/tracked ids

      const [x1, y1, x2, y2] = d.bbox.map((v: any) => Number(v));
      const sx = Math.round(x1 * scaleX);
      const sy = Math.round(y1 * scaleY);
      const sw = Math.round((x2 - x1) * scaleX);
      const sh = Math.round((y2 - y1) * scaleY);

      ctx.strokeStyle = 'red';
      ctx.fillStyle = 'red';
      ctx.strokeRect(sx, sy, sw, sh);
      const txt = `${d.label}${d.id ? ` #${d.id}` : ''}`;
      ctx.fillText(txt, sx + 4, sy + 14);
    }
  }

  // temporary render overlay (draw live drawing rectangle)
  renderOverlay() {
    const canvas = this.overlayEl?.nativeElement;
    const video = this.videoEl?.nativeElement;
    if (!canvas || !video) return;
    const ctx = canvas.getContext('2d')!;
    // first draw tracked boxes
    this.drawDetections();

    if (this.drawing || this.drawConfirmed) {
      const x = Math.min(this.startX, this.curX);
      const y = Math.min(this.startY, this.curY);
      const w = Math.abs(this.curX - this.startX);
      const h = Math.abs(this.curY - this.startY);
      ctx.save();
      ctx.lineWidth = 2;
      ctx.setLineDash([6, 4]);
      ctx.strokeStyle = 'cyan';
      ctx.strokeRect(x, y, w, h);
      ctx.restore();
    }
  }

  resizeOverlay() {
    const video = this.videoEl.nativeElement;
    const canvas = this.overlayEl.nativeElement;
    if (!video || !canvas) return;

    canvas.width = video.clientWidth;
    canvas.height = video.clientHeight;

    this.drawDetections();
  }

  private applyVideoAspectRatio() {
    const video = this.videoEl.nativeElement;
    const container = video.parentElement as HTMLElement;
    if (!video || !container) return;

    const vw = video.videoWidth;
    const vh = video.videoHeight;
    if (!vw || !vh) return;

    // 960x1080 => ~0.888
    const aspect = vw / vh;

    const containerWidth = container.clientWidth;
    const displayHeight = Math.round(containerWidth / aspect);

    video.style.width = `${containerWidth}px`;
    video.style.height = `${displayHeight}px`;
    if (container) {
      container.style.height = `${displayHeight}px`;
    }
  }

  // When user clicks thumbnail to select tracking target (unchanged)
  async selectThumbnail(det: any) {
    if (!det || !det.id) {
      try { alert('Invalid selection'); } catch { }
      return;
    }
    try {
      await this.api.setMonitorTargets(this.cameraId, [{ id: det.id, label: det.label }]).toPromise();
      // also update local trackedIds
      const arr = [...this.trackedIds];
      if (!arr.includes(det.id)) arr.push(det.id);
      this.trackedIds = arr;
      this.showToast('Tracking set', `Tracking ${det.label} id=${det.id}`);
    } catch (e) {
      console.error(e);
      try { alert('Failed to set monitor'); } catch { }
    }
  }

  setupWebsocket() {
    const subject = this.ws.connectAlerts(this.cameraId);
    this.wsSub = subject.subscribe((payload: any) => {
      this.showToast(`${payload.label}`, payload.message);
    });
  }

  showToast(title: string, message?: string) {
    const id = Date.now() + Math.floor(Math.random() * 1000);
    const entry = { id, title, message, ts: new Date().toISOString() };
    this.alerts = [entry, ...this.alerts];
    setTimeout(() => this.alerts = this.alerts.filter((e: any) => e.id !== id), 5000);
  }

  async stop() {
    await this.api.stopStream({
      ip: this.ip,
      username: this.username,
      password: this.password,
      channel_id: this.channelId
    }).toPromise().catch(() => { });
    if (this.hls) this.hls.destroy();
    if (this.wsSub) this.wsSub.unsubscribe();
    this.stopDetectionsPolling();
    this.streaming = false;
    this.selectedCamera = null;
    // this.router.navigate(['/devices']);
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    this.selectedFiles = Array.from(input.files);
  }

  async uploadObjectImages() {
    if (!this.cameraId || !this.objectId || !this.objectLabel || this.selectedFiles.length === 0) {
      this.showToast('Upload failed', 'Missing fields or images');
      return;
    }

    try {
      const res: any = await this.api
        .registerObject(
          this.cameraId,
          this.objectId,
          this.objectLabel,
          this.selectedFiles
        )
        .toPromise();

      if (res?.status === 'ok') {
        this.showToast(
          'Object registered',
          `ID: ${res.object_id}`
        );
        this.selectedFiles = [];
      } else {
        this.showToast('Upload failed', 'Backend error');
      }
    } catch (err) {
      console.error(err);
      this.showToast('Upload failed', 'Request error');
    }
  }

  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', this.boundFullscreenChange);
    if (this.streaming) this.stop();
  }

  toggleFullscreen() {
    if (!this.streaming) return;
    const elem = this.videoWrapperEl.nativeElement;
    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if ((elem as any).webkitRequestFullscreen) { /* Safari */
        (elem as any).webkitRequestFullscreen();
      } else if ((elem as any).msRequestFullscreen) { /* IE11 */
        (elem as any).msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) { /* Safari */
        (document as any).webkitExitFullscreen();
      } else if ((document as any).msExitFullscreen) { /* IE11 */
        (document as any).msExitFullscreen();
      }
    }
  }
}